export default __webpack_public_path__ + "static/media/notificationIcon.57c8f72d.svg";